<div class="topic-messages-view">
  <div class="topic-messages-header">
    <h2 class="topic-messages-title">{{ title }} @if (msgs?.length > 0) {
      <span>({{ msgs?.length }})</span>
    }</h2>
    @if (dialogRef) {
      <button type="button" class="close-btn" (click)="close()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    }
  </div>

  @if (loading) {
    <div class="loading-state">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4"></p-progressSpinner>
      <span>Loading statement messages...</span>
    </div>
  }

  @if (error && !loading) {
    <div class="error-state">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ error }}</span>
    </div>
  }

  @if (!loading && !error && msgs?.length === 0) {
    <div class="empty-state">
      <span>No messages found.</span>
    </div>
  }

  @if (!loading && !error && msgs?.length > 0) {
    <div class="topic-messages-list">
      <p-table [value]="msgs" [responsive]="true" styleClass="p-datatable-striped" [autoLayout]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>Status</th>
            <th>Recipients</th>
            <th>Sent Date</th>
            <th>Effective Date</th>
            <th>Confirmation Num</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-msg>
          <tr>
            <td>
              @if (msg.sentDate) {
                <span>Sent</span>
              }
              @if (!msg.sentDate) {
                <span>—</span>
              }
            </td>
            <td>
              @if ((msg.msgRecipientAPIList?.length || 0) > 0) {
                <div class="recipients-cell">
                  @for (r of msg.msgRecipientAPIList; track r; let last = $last) {
                    <div class="recipient-row">
                      <div class="recipient-email">
                        <a href="#" class="recipient-link" (click)="openRecipientDetail(r, $event)">{{ r.email }}</a>
                      </div>
                      <div class="recipient-stats">
                        @if (r; as stats) {
                          @for (entry of mailStatEntries; track entry) {
                            <span class="mail-stat-item" [pTooltip]="getTooltip(entry, stats)" tooltipPosition="top">
                              <i class="pi {{ entry.icon }}" [attr.aria-label]="entry.label"></i>
                              <span class="mail-stat-badge">{{ getDisplayCount(entry, stats) }}</span>
                            </span>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (!msg.msgRecipientAPIList?.length) {
                <span>—</span>
              }
            </td>
            <td>{{ msg.sentDate ? formatDate(msg.sentDate) : '—' }}</td>
            <td>{{ msg.effectiveDate ? formatDate(msg.effectiveDate) : '—' }}</td>
            <td>{{ msg.msgId || '—' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">No messages found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  @if (selectedRecipient) {
    <div class="recipient-detail-backdrop" (click)="closeRecipientDetail()"></div>
  }
  @if (selectedRecipient) {
    <div class="recipient-detail-popup">
      <div class="recipient-detail-header">
        <strong>Recipient details</strong>
        <button type="button" class="close-btn" (click)="closeRecipientDetail()" aria-label="Close">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="recipient-detail-body">
        <table class="detail-table">
          <tbody>
            @for (entry of getRecipientDetailEntries(selectedRecipient); track entry) {
              <tr>
                <td class="detail-label">{{ keyValueList?.hasOwnProperty(entry.key) ? keyValueList[entry.key] : entry.key }}</td>
                <td class="detail-value">{{ entry.value }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
